const files = import.meta.glob('./*.md', { query: '?raw', import: 'default', eager: true }) as Record<string, string>;

/** Menu order. Add a new article's slug here. */
const ORDER = ['getting-started', 'planning-sessions', 'publishing-sessions', 'drills', 'court-diagrams', 'season-planning', 'roster-and-attendance', 'courtside-mode', 'game-day', 'teams-and-roles', 'invites', 'players-and-parents', 'two-step-sign-in', 'passwords-and-sign-in'];

/** What players and parents see in Help: just what they need. Coaches see everything. */
export const PLAYER_ARTICLES = ['players-and-parents', 'passwords-and-sign-in', 'two-step-sign-in'];

export interface HelpArticle {
  slug: string;
  title: string;
  body: string;
}

export const ARTICLES: HelpArticle[] = ORDER.map((slug) => {
  const raw = files[`./${slug}.md`] ?? `# ${slug}\n\nMissing article.`;
  const [first, ...rest] = raw.split('\n');
  return { slug, title: first!.replace(/^#\s*/, ''), body: rest.join('\n').trim() };
});
